import axios from 'axios';
import parser from 'xml-js';

const getPesquisa = async () => {

    let response = await axios.get(window.url_api+'/app/zws_app_buscar_gp_pesquisa?centro='+localStorage.getItem('centro'));
    response = parser.xml2json(response.data, {compact: true, spaces: 4});
    response = JSON.parse(response);
    if(response['soap-env:Envelope']['soap-env:Body']['n0:ZMM_WS_APP_BUSCAR_GP_PESQUISAResponse']['S_MENSAGEM']._text === 'Sucesso') {
      const isAtacado = response['soap-env:Envelope']['soap-env:Body']['n0:ZMM_WS_APP_BUSCAR_GP_PESQUISAResponse']['S_TIPO_LOJA']._text === 'A';
      return {
        atacado: isAtacado,
        items: response['soap-env:Envelope']['soap-env:Body']['n0:ZMM_WS_APP_BUSCAR_GP_PESQUISAResponse']['T_DADOS_GP_PESQUISA']['item']
      };
    }

    return [];

};



export default {
  getPesquisa,
};
